import { createFilterOptions, FilterOptionsState } from '@mui/material';
import { Project } from 'services/projects';
import {
  fetchProjectsAPI,
  getProjectsByCustomerId,
} from 'services/projects/api';

import { Pagination } from 'services/search';

const filter = createFilterOptions<Project>();

export const projectsAutocompleteOptionLabel = (project: Project) => {
  return project.name || '';
};

export const projectsAutocompleteFilterOptions = (
  options: Project[],
  params: FilterOptionsState<Project>
) => {
  return filter(options, params);
};

export const resolvedFetchProjectsFunction = (
  expands?: string[],
  customQuickSearchColumns?: string[],
  customerId?: number | null
) => {
  return async (pagination: Pagination, searchValue: string | null) => {
    // If customerId is provided, fetch projects filtered by customer
    if (customerId) {
      try {
        const projects = await getProjectsByCustomerId(customerId);
        // Filter by search value if provided
        let filteredProjects = projects;
        if (searchValue) {
          filteredProjects = projects.filter((project) =>
            project.name?.toLowerCase().includes(searchValue.toLowerCase())
          );
        }
        return {
          data: filteredProjects,
          pagination: {
            ...pagination,
            totalRows: filteredProjects.length,
          },
        };
      } catch (error) {
        console.error('Error fetching projects by customer:', error);
        return {
          data: [],
          pagination: {
            ...pagination,
            totalRows: 0,
          },
        };
      }
    }

    // Default behavior: fetch all projects (for Purchase Orders)
    return fetchProjectsAPI({
      pagination,
      expands: expands,
      quickSearchValue: searchValue,
      customQuickSearchColumns,
    });
  };
};
